<script lang="ts">
  import InlineSVG from 'svelte-inline-svg';
  import {searchText} from '../../stores/filter-and-sort';

  import searchIcon from '../../assets/icons/search.svg';
  import clearIcon from '../../assets/icons/cross.svg';

  import IconButton from '../icon-button/IconButton.svelte';

  let searchInputElement: HTMLInputElement | null = null;
</script>

<style lang="postcss">
  .searchContainer {
    position: relative;
    display: flex;
    align-items: center;
    height: var(--ubilabs-input-height);
  }

  .searchContainer :global(.search-icon) {
    position: absolute;
    left: 0.25rem;
  }

  .searchContainer :global(.search-clear-icon) {
    position: absolute;
    right: 0.25rem;
  }

  input {
    width: 100%;
    padding-left: 2.5rem;
    transition-property: padding, width;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
  }

  @media (min-width: 640px) {
    input {
      width: 0;
      padding-left: 1.5rem;
      border-color: transparent;
      background: transparent;
    }

    input:focus,
    .filled {
      width: var(--ubilabs-input-width);
      padding: 0 2.5rem;
      border: var(--ubilabs-input-border);
      background: var(--ubilabs-input-background-color);
    }
  }
</style>

<div class="searchContainer">
  <IconButton class="search-icon" on:click={() => searchInputElement?.focus()}>
    <InlineSVG src={searchIcon} />
  </IconButton>

  <input
    placeholder="Search"
    class:filled={Boolean($searchText)}
    bind:value={$searchText}
    bind:this={searchInputElement} />

  {#if $searchText}
    <IconButton
      class="search-clear-icon"
      on:click={() => {
        searchText.reset();
        searchInputElement?.focus();
      }}>
      <InlineSVG src={clearIcon} />
    </IconButton>
  {/if}
</div>
